export enum FormRowType {
    Text = "Text",
    Note = "Note",
    Email = "Email",
    Date = "Date",
    DateTime = "DateTime",
    Time = "Time",
    DateRange = "DateRange",
    Integer = "Integer",
    Float = "Float",
    Choice = "Choice",
    Boolean = "Boolean",
    Password = "Password",
    Location = "Location",
    CurrentLocation = "CurrentLocation",
    FilterChoice = "FilterChoice",
    File = "File",
    Files = "Files",
    Image = "Image",
    ViewCell = "ViewCell",
    Signature = "Signature",
    Color = "Color",
    Translations = "Translations",
    Telephone = "Telephone",
    BankAccount = "BankAccount",
    UnlimitedFile = "UnlimitedFile",
    Link = "Link"
}
